var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstantBooking22X22Blue = function SvgInstantBooking22X22Blue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#0A4195",
    stroke: "#F4C064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 16.437H8.126a.487.487 0 0 1-.383-.789l7.147-9.096c.32-.408.971-.1.859.407l-1.168 5.255h5.24c.405 0 .633.463.386.784l-6.497 8.447c-.303.393-.931.135-.87-.358l.582-4.65Z",
    fill: "#F4C064"
  })));
};
export default SvgInstantBooking22X22Blue;